<template>
	<div class="full-screen">
		<!-- Top Buttons -->
		<div class="outer">
			<div class="left-side">
				<div class="button-row">
					<div class="dimension-button" :class="`${listToShow == 'merged' ? 'on' : 'off'}`"
						@click="displayMerged()" @contextmenu="getMoreMembers($event)">
						<img src="../../../static/p.png" /><br />
						{{ totalResults }}
					</div>
					<div v-for="dim in dimensions" class="dimension-button"
						:class="`${listToShow == dim.name ? 'on' : 'off'}`" :key="dim.name" @click="displayResults(dim)"
						:style="`background-color: ${dim.totalResults >= 0 ? '#bcdbf6' : '#e9f3fc'
							 	}`">
						<img v-if="dim.imageURL" :src="dim.imageURL" /><br />
						{{ dim.totalResults > 0 ? dim.totalResults : "" }}
					</div>
				</div>

				<!-- Weight Controls -->
				<div v-show="listToShow == 'merged'">
					<div ref="weights" class="weight-box" @mousemove="adjustWeight($event)"
						@mouseleave="stopAdjustWeight()" @mouseup="stopAdjustWeight()">
						<div class="adjuster" @click="showIntents = !showIntents">
							{{ intentText }}
						</div>

						<!-- Intent Picker -->
						<div v-if="showIntents" class="picker intent-picker">
							<div v-for="preset in weightPresets" :key="preset['intent']" class="button-row"
								@click="pickIntent(preset)">
								<div class="picklist-item" style="flex-grow: 10">
									{{ preset["intent"] }}
								</div>
							</div>
						</div>

						<div class="weight" v-for="dim in dimensions" :key="'btn-' + dim.name"
							@mousedown="startAdjustWeight(dim, $event)">
							<div class="weight-column" :style="`background-color: ${dim.totalResults <= 0 ? '#cccccc' : dim.color
									 	};height:${dim.weight}px`"></div>
							<div v-if="dim.totalResults > 0" class="weight-number">
								{{ dim.weight }}
							</div>
						</div>
					</div>
				</div>

				<!-- Terms -->
				<div class="term-row" v-if="listToShow != 'merged' && ask.matchingCriteria && matchingCriteriaDim && matchingCriteriaDim.terms">
					<div v-for="(term, idx) in matchingCriteriaDim.terms" :key="term.term + idx" class="term"
						:style="`color:${termColor}`" @click="displayTermPanel(idx)"
						@contextmenu="removeTerm(idx, $event)">
						{{ term.required ? term.term.toUpperCase() : term.term }}
					</div>
					<!-- Add term -->
					<div class="term" :style="`color:${termColor}`" @click="displayAddTerm()">
						+Add
					</div>
				</div>

				<!-- Add Term Popup -->
				<div v-show="showAddTerm" class="term-box" :style="`border-color:${termColor}`">
					<input type="text" class="add-box" :style="`border-color:${termColor};color:${termColor}`"
						ref="addBox" v-model="newTerm" placeholder="Term to add" @keyup.enter="addTerm(false)"
						@keyup.esc="escapeTerm()" tabindex="0" />
					<button class="gemini-btn" @click="addTerm(true)">Add</button>
					<button class="gemini-btn" @click="cancelTerm()">Cancel</button>
				</div>

				<!-- Merged and Dimension Matches -->
				<div v-if="merged.length == 0">{{ searchingText }}</div>
				<TinyAdvisor v-for="member in listToShow == 'merged'
										 	? merged
										 	: dimensions.find((d) => d.name == listToShow).results" :key="member._id" :member="member" :ask="ask" />

			</div>

			<!-- Right side -->
			<div class="right-side">
				<!-- Circle -->
				<div v-if="ask.sourceparam">
					From {{ ask.sourceparam }}
				</div>
				<!-- Name and links -->
				<div class="name-and-links">
					<span style="cursor: help" :title="`${ask.subject}\n\n ${ask.text}`">&lt;?&gt;</span>

					<a :href="`/members/${asker._id}`" target="_blank">{{
						asker.displayName
						}}</a>
					<span v-for="(term, idx) in quickTags" :key="`qt:${idx}`" :style="`color: ${getTermColor(
								term.dimension.name
							)}; cursor: pointer`" @click="doAddEmittedTerm(term)">
						/ {{ term.tag }}
					</span>
				</div>

				<!-- Buttons -->
				<!--button class="gemini-btn" @click="goToTags()">Tag</button-->
				<button class="gemini-btn" @click="updateMatchingCriteria()">Search</button>
			<button class="gemini-btn" @click="assignDimensionTags()">Tag</button>
				<button class="gemini-btn" @click="initialAssign()">Assign</button>
				<button class="gemini-btn" @click="removeAllAdvisors()">Remove All Advisors</button>
				<br />
				<!-- After the Tag button click, show this inline -->
				<div v-if="showFeedback" class="feedback-row">
					<span class="feedback-label">Were the tags accurate?</span>
					<button class="gemini-btn" :class="{ active: feedbackRating === 'up' }"
						@click="setRating('up')">👍</button>
					<button class="gemini-btn" :class="{ active: feedbackRating === 'down' }"
						@click="setRating('down')">👎</button>

					<div v-if="feedbackRating" class="chip-row">
						<span v-for="chip in currentChips" :key="chip" class="chip"
							:class="{ selected: selectedChips.includes(chip) }" @click="toggleChip(chip)">
							{{ chip }}
						</span>
					</div>

					<textarea v-if="feedbackRating" v-model="feedbackComment" class="feedback-comment"
						placeholder="Any additional comments..." maxlength="300" />

					<button v-if="feedbackRating" class="gemini-btn" @click="submitFeedback()">Submit</button>
					<button class="gemini-btn" @click="showFeedback = false">Cancel</button>
				</div>
				<div class="info-header">
					Matching
					{{ ask.recommendedAdvisors ?ask.recommendedAdvisors.length : 0 }} of
					{{ community.rules.minimum_advisors }} -
					{{ community.rules.maximum_advisors }}
				</div>

				<div v-if="ask.matchingCriteria && ask.matchingCriteria.assignment">
					Match <clicker style="number" v-model="ask.matchingCriteria.assignment.initial"></clicker>
					add <clicker style="number" v-model="ask.matchingCriteria.assignment.refill"></clicker>
					every <clicker style="number" v-model="ask.matchingCriteria.assignment.days"></clicker> days
					for <clicker style="number" v-model="ask.matchingCriteria.assignment.responses"></clicker> responses
				</div>
				<br />
				<div class="outer criteria-info">
					<div>Automatically refill</div>
					<div>
						<input type="checkbox" v-model="ask.matchingCriteria.assignment.autoRefill" />
					</div>
				</div>
				<div v-show="showPanel == 'global' && ask.matchingCriteria" class="info-panel">
					<div class="criteria-header">Filters</div>
					<div class="outer criteria-info">
						<div>Bypass Engagement Date Filter</div>
						<div>
							<input type="checkbox" v-model="
										ask.matchingCriteria.filters.bypassEngagementDateFilter
									" />
						</div>
					</div>

					<div class="outer criteria-info">
						<div>Exclude Existing Matches</div>
						<div>
							<input type="checkbox" v-model="ask.matchingCriteria.filters.excludeExistingMatches" />
						</div>
					</div>

					<div class="outer criteria-info">
						<div>Bypass Quality Blocking</div>
						<div>
							<input type="checkbox" v-model="ask.matchingCriteria.filters.bypassQualityBlocking" />
						</div>
					</div>

					<div class="outer criteria-info" v-if="community.additionalParams.length"
						style="display: flex; align-items: center; gap: 10px;">

						<div style="display: flex; align-items: center; gap: 6px;">
							<span>Only in Circle:</span>
							<CustomDropdown v-model="ask.matchingCriteria.filters.circleLimit.ref_code"
								:options="community.additionalParams" placeholder="Select Circle" />
						</div>

						<input type="checkbox" v-model="ask.matchingCriteria.filters.circleLimit.active"
							style="margin-left: auto;" />
					</div>

					<div class="criteria-header">Equalizers</div>
					<div class="outer criteria-info">
						<div>Normalize Dimensions</div>
						<div>
							<input type="checkbox" v-model="ask.matchingCriteria.equalizers.normalizeDimensions" />
						</div>
					</div>

					<div class="criteria-header">Exclusions</div>
					<div class="outer criteria-info">
						<div>Allow Single Dimension Matches</div>
						<div>
							<input type="checkbox"
								v-model="ask.matchingCriteria.exclusions.allowSingleDimensionMatches" />
						</div>
					</div>

					<div class="outer criteria-info">
						<div>Strategy Matches Only</div>
						<div>
							<input type="checkbox" v-model="ask.matchingCriteria.exclusions.strategyMatchesOnly" />
						</div>
					</div>

					<div class="outer criteria-info">
						<div>Cutoff Percentage</div>
						<div>
							<input class="option-number" type="number"
								v-model="ask.matchingCriteria.exclusions.cutoffPercentage" />
						</div>
					</div>

					<div class="criteria-header">Selection Strategy and Goals</div>
					<div class="outer">
						<select class="new-picker" v-model="selectedStrategy" @change="updateGoals()">
							<option v-for="strategy of strategies" :value="strategy" :key="strategy">{{ strategy }}
							</option>
						</select>
					</div>

					<div class="outer criteria-info" v-for="(strategy, idx) in ask.matchingCriteria.selectionStrategies"
						:key="strategy[0]">

						<div style="display: flex; align-items: center; gap: 6px;">
							<clicker v-if="strategy[2] && strategy[2] > 0" mode="dice"
								v-model="ask.matchingCriteria.selectionStrategies[idx][2]" :color="`${colors[idx]}`" />
							<b v-if="!(strategy[2] && strategy[2] > 0)" class="strategy-dot"
								:style="`color:#${colors[idx]}`">⬤</b>

							{{ strategy[0] }}

							<CustomDropdown v-if="strategy[0] === 'In Circle'"
								v-model="ask.matchingCriteria.selectionStrategies[idx][3]"
								:options="community.additionalParams" placeholder="Select Circle" />
						</div>

						<div>
							<clicker mode="number" v-model="ask.matchingCriteria.selectionStrategies[idx][1]"
								color="blue" />
						</div>

					</div>

				</div>

				<div v-if="
					showPanel == 'dimension' &&
					ask.matchingCriteria &&
					matchingCriteriaDim
				" class="info-panel">
					<div class="info-header" :style="`color:${termColor}`">
						{{ listToShow }} Criteria
					</div>
					<div class="outer criteria-info">
						<div>Weight</div>
						<div v-if="matchingCriteriaDim">
							<input class="option-number" v-model="matchingCriteriaDim.weight" type="number"
								@change="updateWeight()" />
						</div>
					</div>
				</div>
				<div v-if="showPanel == 'term' && showingTerm >= 0 && matchingCriteriaDim && matchingCriteriaDim.terms" class="info-panel">
					<div class="info-header">Term Details</div>

					<div class="outer criteria-info">
						<div>Term</div>
						<div>
							<input v-model="matchingCriteriaDim.terms[showingTerm].term" class="option-text"
								type="text" />
						</div>
					</div>

					<div class="outer criteria-info">
						<div>Required</div>
						<div>
							<input v-model="matchingCriteriaDim.terms[showingTerm].required" type="checkbox" />
						</div>
					</div>

					<div class="outer criteria-info">
						<div>Score</div>
						<div>
							<input v-model="matchingCriteriaDim.terms[showingTerm].score" class="option-number"
								type="number" />
						</div>
					</div>
					<br />
					<div class="remove" @click="removeTerm(showingTerm, $event)">
						🗑️ &nbsp; Remove
						{{ matchingCriteriaDim.terms[showingTerm].term }}
					</div>
				</div>
				<br />
			</div>
		</div>
	</div>
</template>

<script>
import API from "@/services/API";
import TinyAdvisor from '@/components/gemini/TinyAdvisor.vue';
import Clicker from '@/components/gemini/Clicker.vue';
import '@/components/gemini/styles.css';
import Config from '@/utils/config';
import CustomDropdown from '@/components/CustomDropdown.vue';

export default {
	components: {
		Clicker,
		TinyAdvisor,
		CustomDropdown
	},
	data() {
		return {
			adjusting: "",
			adjustingY: 0,
			adjustingStart: 0,
			api: new API(),
			showFeedback: false,
			feedbackRating: null,
			selectedChips: [],
			feedbackComment: '',
			chipsDown: [
				'Tags too broad',
				'Tags too narrow',
				'Wrong dimension category',
				'Missing key tags',
				'Irrelevant tags added'
			],
			chipsUp: [
				'Tags captured the request well',
				'Good dimension separation',
				'Nothing missing',
				'No irrelevant tags',
				'Correct specificity'
			],
			ask: {
				matchingCriteria: {
					assignment: {
						initial: 0,
						refill: 0,
						days: 0,
						responses: 0,
						autoRefill: false
					},
					filters: {
						bypassEngagementDateFilter: false,
						excludeExistingMatches: false,
						bypassQualityBlocking: false,
						circleLimit: {
							ref_code: "",
							active: false
						}
					},
					equalizers: {
						normalizeDimensions: false
					},
					exclusions: {
						allowSingleDimensionMatches: false,
						strategyMatchesOnly: false,
						cutoffPercentage: 0
					},
					selectionStrategies: []
				}
			},
			asker: {},
			colors: ["006ba6", "70d6ff", "b6af6d", "1a535c", "badca1", "ea9770", "ffd670", "6a2317", "ca1bad", "3f0dc4", "fecda4", "2bff70", "ff7006", "008800", "ff0000", "654321", "789abc", "165f9d"],
			community: { additionalParams: [], rules: { minimum_advisors: '-', maximum_advisors: '-' } },
			dimensions: [],
			intentText: "Adjust Defaults",
			listToShow: "merged",
			matchingCriteriaDim: {},
			memberLimit: 100,
			merged: [],
			newTerm: "",
			quickTags: [],
			searchingText: "To load data, click the Search button.",
			selectedStrategy: "Accelerate Major Gifts",
			showAddTerm: false,
			showIntents: false,
			showPanel: "global",
			showingTerm: -1,
			strategies: ["Activate Lapsed Donors", "Activate Unengaged Alumni", "Activate Unengaged Donors", "Accelerate Major Gifts", "Major Campaign", "Activate Unengaged/Lightly Engaged Young Alumni", "Engage Existing Donors"],
			termColor: "purple",
			totalResults: 0,
			weightPresets: Config.GEMINI_CONFIGS
		};
	},
	computed: {
		currentChips() {
			return this.feedbackRating === 'up' ? this.chipsUp : this.chipsDown;
		}
	},
	created() {
		this.$eventHub.$on('gemini-add-term', this.doAddEmittedTerm);
	},
	beforeDestroy() {
		this.$eventHub.$off("gemini-add-term");
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData: function () {
			this.dimensions = [];
			Config.GEMINI_DIMENSIONS.forEach((dim) => {
				this.addDimension(dim.name, dim.color);
			});
			this.api.get(`asks/${this.$route.params.ask_id}`).then(ask => {
				this.ask = ask.data;
				if (this.ask) {
					//this.getSearchResults();
					this.asker = this.api.get(`members/${this.ask.createdByMemberID._id}`).then(res => {
						this.asker = res.data;
					});
					this.api.get(`communities/${this.ask.community._id ? this.ask.community._id : this.ask.community}`).then(res => {
						this.community = res.data;
						for (let s of this.ask.matchingCriteria.selectionStrategies) {
							if (s[1] < 1) {
								s[1] = Math.round(s[1] * this.community.rules.minimum_advisors)
							}
						}
						this.community.additionalParams = this.community.additionalParams.sort((a, b) => a.name > b.name ? 1 : -1)
										});
				}
			});	
		},
		removeAllAdvisors: function () {
			this.ask.recommendedAdvisors = [];
			this.api.post(`asks/${this.ask._id}/match`, {removealladvisors: 'removeall'}).then(response => {
				console.log("Matched advisors removed")
			});
		},
		addDimension(name, color) {
			this.dimensions.push({
				name: name,
				color: color,
				imageURL: `../../../static/${name}.png`,
				weight: 100,
				results: [],
				totalResults: -1
			});
		},
		goToTags() {
			window.open(`/gemini/${this.ask._id}`, "_self");
		},
		assignDimensionTags: async function () {
			await this.api.post(`asks/${this.$route.params.ask_id}/assign-dimension-tags`, {
				analysis: this.ask.analysis,
				matchingCriteria: this.ask.matchingCriteria
			});
			await this.loadData();
			this.showFeedback = true; // show feedback after tagging
			this.$toast.success('Dimension tags assigned.');
		},
		setRating(rating) {
			this.feedbackRating = rating;
			this.selectedChips = [];
		},
		toggleChip(chip) {
			const idx = this.selectedChips.indexOf(chip);
			idx > -1 ? this.selectedChips.splice(idx, 1) : this.selectedChips.push(chip);
		},
		submitFeedback: async function () {
			await this.api.post(`asks/${this.$route.params.ask_id}/analysis-feedback`, {
				rating: this.feedbackRating,
				chips: this.selectedChips,
				comment: this.feedbackComment
			});
			this.showFeedback = false;
			this.feedbackRating = null;
			this.selectedChips = [];
			this.feedbackComment = '';
			this.$toast.success('Feedback submitted.');
		},
		initialAssign() {
			const threshold = this.community.rules.matchingThreshold || 60;
			const ratio = this.community.rules.minimum_advisors_ratio || 3;

			// Filter advisors who meet the totalScore threshold and are not already matched
			const eligible = this.merged
				.filter(m => m.matchDetails.totalScore >= threshold)
				.sort((a, b) => b.matchDetails.totalScore - a.matchDetails.totalScore);

			const topAdvisors = eligible.slice(0, ratio).map(m => m._id);

			if (topAdvisors.length === 0) {
				this.searchingText = "No advisors met the threshold.";
				this.$toast.error("No advisors met the threshold: " + threshold);
				return;
			}

			const newAdvisors = topAdvisors.filter(id => !this.ask.recommendedAdvisors.includes(id));
			this.ask.recommendedAdvisors.push(...newAdvisors);

			this.api.post(`asks/${this.ask._id}/match`, { advisors: this.ask.recommendedAdvisors })
				.then(() => {
					console.log(`Matched top ${newAdvisors.length} advisors (≥${threshold})`);
					this.searchingText = `Matched top ${newAdvisors.length} advisors successfully.`;
				})
				.catch(err => {
					console.error("Error matching advisors:", err);
					this.searchingText = "Error while matching advisors.";
				});
			this.$toast.success("Advisors added");

		},

		getTermColor(name) {
			return this.dimensions.find(d => d.name == name).color;
		},
		updateQuickTags: async function () {
			this.quickTags = []
			let tags = [];
			// Add circle code
			if (this.ask.sourceparam) {
				let circleIndexTerm = this.community.additionalParams.find(c => c.name == this.ask.sourceparam);
				if (circleIndexTerm) {
					console.log("It is", circleIndexTerm);
					tags.push({dimension: {name: "demographic"}, tag: this.clean(circleIndexTerm.short), required: false});
				}
			}
			// Add terms from asker's profile
			tags.push({dimension: {name: "education"}, tag: this.asker.school1, required: false});
			tags.push({dimension: {name: "occupation"}, tag: this.asker.organization, required: false});
			tags.push({dimension: {name: "occupation"}, tag: (this.asker.roles[0] || ""), required: false});

			// Add tags from ask as skillls terms
			for (var tag of this.ask.tags) {
				tags.push({dimension: {name: "skills"}, tag: tag.toLowerCase().trim(), required: false});
			}

			// Add unmatched terms from dimensions
			for (let dim of this.dimensions) {
				let mcDim = this.ask.matchingCriteria.dimensions.find(d => d.name == dim.name);
				for (let dimTerm of this.ask.dimensions[dim.name]) {
					if (!mcDim || !mcDim.terms.some(t => t.term == dimTerm)) {
						tags.push({dimension: {name: dim.name}, tag: dimTerm, required: false});
					}
				}
			}
			// Add single words of multi-word terms
			for (var dim of this.ask.matchingCriteria.dimensions) {
				for (var t of dim.terms) {
					let words = t.term.split(" ");
					if (words.length > 1) {
						for (var word of words) {
							if (!dim.terms.some(t => t.term == word)) {
								tags.push({dimension: {name: dim.name}, tag: word, required: false});
							}
						}
					}
				}
			}
			tags = tags.filter(t => !Config.WORD_IGNORE_LIST.includes(t.tag))

			// Add any unmatched terms to the Quicktags
			for (var qt of tags) {
				if (qt.tag) {
					qt.tag = qt.tag.toLowerCase().trim();
					let mcDim = this.ask.matchingCriteria.dimensions.find(d => d.name == qt.dimension.name);
					if (!mcDim || !mcDim.terms.some(t => t.term == qt.tag)) {
						if (!this.quickTags.some(t => (t.tag == qt.tag && t.dimension.name == qt.dimension.name))) {
							this.quickTags.push(qt);
						}
					}
				}
			}
		},
		getSearchResults: function () {
			this.searchingText = "Searching....";
			this.merged = [];
			this.listToShow = "merged";
			this.showPanel = "global";

			this.api.get(`asks/${this.ask._id}/search-dimensions?limit=${this.memberLimit}`)
				.then(res => {
				//console.log("Got back from search results!!!!", res.data);
				this.merged = res.data.members;
				this.totalResults = res.data.count;
				if (this.totalResults == 0) {
					this.searchingText = "No results";
				} else {
					this.dimensions.forEach((dim) => {
					dim.results = [];
					dim.totalResults = 0;
					dim.weight = this.ask.matchingCriteria.dimensions.find(d => d.name == dim.name).weight;
					let dimmembers = this.merged.filter(member => 
						member.matchDetails.dimensions.some(md => md.name == dim.name) &&
						(
							member.circles && member.circles.includes(this.ask.matchingCriteria.filters.circleLimit.ref_code)
						)
					);
					if (dimmembers && dimmembers.length) {
						dim.results = dimmembers;
						dim.totalResults = dimmembers.length;
					}
					});
				}
				this.updateQuickTags();
				})
				.catch(error => {
				console.error('Fetch error:', error);
				// Handle the error, e.g., show an error message to the user
				this.searchingText = "An error occurred while fetching data";
			});
		},
		displayMerged: function (dim) {
			this.listToShow = "merged";
			this.showPanel = "global";
		},
		displayResults: function (dim) {
			this.listToShow = dim.name;
			let match = this.ask.matchingCriteria.dimensions.find(d => d.name == this.listToShow);
			if (!match) {
				// This dimension has no matching-criteria entry yet (e.g. it was
				// added to config after this ask's criteria was last generated).
				// Create one instead of leaving matchingCriteriaDim undefined.
				match = { name: dim.name, weight: dim.weight || 100, terms: [] };
				this.ask.matchingCriteria.dimensions.push(match);
			}
			this.matchingCriteriaDim = match;
			this.showPanel = "dimension";
			this.termColor = dim.color;
		},
		displayTermPanel: function (idx) {
			this.showPanel = "term";
			this.showingTerm = idx;
		},
		startAdjustWeight: function (dim, evt) {
			this.adjusting = dim.name;
			this.intentText = "Custom Weighting";
			this.adjustWeight(evt);
		},
		stopAdjustWeight: function () {
			if (this.adjusting != "") {
				this.adjusting = "";
			}
		},
		updateWeight: function () {
			let dim = this.dimensions.find(f => f.name == this.listToShow);
			dim.weight = this.matchingCriteriaDim.weight;
		},
		adjustWeight: function (evt) {
			if (this.adjusting != "") {
				let distFromTop = evt.pageY - this.$refs.weights.getBoundingClientRect().y - 10; // 10 for padding
				let newWeight = parseInt(100 - distFromTop);
				let dim = this.dimensions.find(f => f.name == this.adjusting);
				dim.weight = Math.max(Math.min(newWeight, 100), 0);
				this.ask.matchingCriteria.dimensions.find(d => d.name == this.adjusting).weight = dim.weight;
			}
		},
		pickIntent(preset) {
			console.log("Pick intent:", preset)
			this.showIntents = false;
			this.intentText = preset["intent"];
			for (let i = 0; i < this.dimensions.length; i++) {
				this.dimensions[i].weight = preset[this.dimensions[i].name];
				this.ask.matchingCriteria.dimensions.find(d => d.name == this.dimensions[i].name).weight = preset[this.dimensions[i].name];
			}
			this.ask.matchingCriteria.assignment.initial = preset.initial;
			this.ask.matchingCriteria.assignment.refill = preset.refill;
			this.ask.matchingCriteria.assignment.days = preset.days;
			this.ask.matchingCriteria.assignment.responses = preset.responses;
		},
		updateGoals: function () {
			console.log("Update goals for", this.selectedStrategy)
			// TODO: Fix with real logic
		},
		displayAddTerm: function () {
			this.showAddTerm = true;
			this.$nextTick(function () {
				this.$refs.addBox.focus();
			});
		},
		addTerm: function (closePopup) {
			if (!this.matchingCriteriaDim || !this.matchingCriteriaDim.terms) return;
			this.matchingCriteriaDim.terms.push({term: this.newTerm.trim().toLowerCase(), score: 1, required: false})
			this.updateQuickTags();
			this.newTerm = "";
			if (closePopup) {
				this.showAddTerm = false;
			}
		},
		escapeTerm: function () {
			if (this.newTerm == "") {
				this.cancelTerm();
			} else {
				this.newTerm = "";
			}
		},
		cancelTerm: function () {
			this.newTerm = "";
			this.showAddTerm = false;
		},
		updateMatchingCriteria: function () {
			console.log("Updating MC", this.ask.matchingCriteria)
			this.api.post(`asks/${this.ask._id}/update-matching-criteria`, {matchingCriteria: this.ask.matchingCriteria}).then(response => {
				this.newTerm = "";
				this.showAddTerm = false;
				this.getSearchResults();
			});
		},
		doAddEmittedTerm: async function (term) {
			let match = this.ask.matchingCriteria.dimensions.find(d => d.name == term.dimension.name);
			if (!match) {
				match = { name: term.dimension.name, weight: 100, terms: [] };
				this.ask.matchingCriteria.dimensions.push(match);
			}
			match.terms.push({term: term.tag, score: 1, required: false});
			this.listToShow = term.dimension.name;
			this.matchingCriteriaDim = match;
			this.termColor = term.dimension.color;
			this.updateQuickTags();
		},
		removeTerm: function (idx, event) {
			event.preventDefault();
			if (!this.matchingCriteriaDim || !this.matchingCriteriaDim.terms) return;
			this.matchingCriteriaDim.terms.splice(idx, 1);
			this.showingTerm = -1;
			this.showPanel = "dimension";
			this.updateQuickTags();
		},
		getMoreMembers: function (event) {
			event.preventDefault();
			this.memberLimit += 100;
			this.getSearchResults();
		},
		clean: function (txt) {
			txt = txt.replace(/[.,#!$%^&*;:{}=+\-_`~()]/g, " "); // Remove punctuation
			txt = txt.replace(/\s{2,}/g, " "); // Remove duplicate spaces
			txt = txt.toLowerCase().trim();
			return txt;
		}
	}
}
</script>

<style scoped>
.feedback-row {
    margin-top: 8px;
    padding: 6px;
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-radius: 3px 0 0 0;
}

.feedback-label {
    font-size: 13px;
    font-weight: 600;
    margin-right: 6px;
}

.chip-row {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 6px;
}

.chip {
    font-size: 12px;
    padding: 2px 8px;
    border: 1px solid #aaa;
    border-radius: 10px;
    cursor: pointer;
    background: #f0f0f0;
}

.chip.selected {
    background: #5c35d4;
    color: white;
    border-color: #5c35d4;
}

.feedback-comment {
    width: 100%;
    margin-top: 6px;
    font-size: 13px;
    padding: 4px;
    border: 1px solid #aaa;
    border-radius: 3px;
    resize: vertical;
}

.gemini-btn.active {
    background: #5c35d4;
    color: white;
}
.outer {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: stretch;
	align-content: stretch;
	margin-top: 3px;
	width: 99%;
}

.left-side {
	width: 99%;
}

.right-side {
	width: 410px;
	margin-left: 5px;
	padding-left: 5px;
	border-left: 2px solid black;
}

.info-header {
	font-weight: 600;
	text-decoration: underline;
	text-transform: capitalize;
	margin-top: 5px;
}

.criteria-header {
	margin-top: 5px;
	font-weight: 600;
	color: rgb(87, 0, 87);
}

.criteria-info {
	border-top: 1px solid black;
	border-left: 1px solid black;
	border-radius: 3px 0px 0px 0px;
	padding: 2px;
}

.option-number {
	width: 50px;
	height: 20px;
}

.option-text {
	width: 100px;
	height: 20px;
}

.remove {
	cursor: pointer;
	color: darkred;
}

.weight-box {
	display: flex;
	align-items: flex-end;
	user-select: none;
	height: 115px;
}

.weight-number {
	margin-top: -20px;
	color: rgb(87, 0, 87);
	cursor: pointer;
}

.weight {
	padding: 5px;
	text-align: center;
	width: 20%;
}

.weight-column {
	border: 1px solid black;
	border-radius: 5px 5px 0px 0px;
	cursor: pointer;
}

.term-row {
	display: flex;
	flex-wrap: wrap;
}

.term {
	padding: 2px 4px 2px 4px;
	margin: 0px 2px 2px 0px;
	text-align: center;
	border-radius: 3px;
	margin: 1px;
	font-size: 14px;
	font-weight: 600;
	text-decoration: underline;
	cursor: pointer;
}

.adjuster {
	border: 2px solid rgba(45, 45, 238, 0.5);
	background-color: rgba(0, 124, 248, 0.1);
	color: black;
	border-radius: 3px;
	align-self: flex-start;
	text-align: center;
	vertical-align: center;
	margin: 10px 1px 2px 2px;
	padding: 3px;
	width: 18%;
	font-size: 14px;
}

.term-box {
	padding: 5px;
	position: fixed;
	background-color: white;
	z-index: 10;
	top: 200px;
	margin-left: 15%;
	border: 3px solid black;
	border-radius: 5px;
}

.add-box {
	font-size: 18px;
	height: 32px;
	padding: 5px;
	vertical-align: middle;
}

.results {
	width: 99%;
}

.name-and-links {
	border: 2px solid purple;
	border-radius: 5px;
	padding: 3px;
	margin-bottom: 5px;
}

.intent-picker {
	left: 20px;
	top: 150px;
}

.picklist-item {
	padding: 3px;
	margin: 0px 2px 2px 0px;
	border: 1px solid black;
	background-color: rgba(0, 124, 248, 0.1);
	border-radius: 3px;
}

.new-picker {
	border-radius: 3px;
	border: 2px solid rgba(45, 45, 238, 0.3);
	background-color: #e7f0f8;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/gemini/Matches.vue